<template>
  <div class="animated fadeIn list-of-aexpense">
    <b-card>
      <div slot="header">List of Expense Reimbursment 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Print Form</b-dropdown-item>
            <b-dropdown-item @click="printjv" :disabled="(model.posting == 0)">Jurnal Voucher</b-dropdown-item>
            <b-dropdown-item @click="printjvmultiple" :disabled="(selected.length==0)">Jurnal Voucher Selected ({{selected.length}}) </b-dropdown-item>
            <b-dropdown-item @click="printpb" >Perintah Bayar</b-dropdown-item>
            <b-dropdown-item @click="printpbmultiple" :disabled="(selected.length==0)">Perintah Bayar Selected ({{selected.length}}) </b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Posting/Accrue" variant="primary mr-1" v-if="((model.iscomplete==1) && (model.issuccess==1))">
            <b-dropdown-item @click="posting" :disabled="!(model.expenKey || model.posting==1 || (model.nomorbank) || selected.length>0)">Posting 1</b-dropdown-item>
            <b-dropdown-item @click="postingselected" :disabled="(selected.length==0)">Posting Selected {{selected.length}} </b-dropdown-item>
            <!-- <b-dropdown-item @click="postingall" >Accrued All</b-dropdown-item> -->
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="unposting" :disabled="!(model.expenKey)|| model.posting==0 || selected.length>0">Unposting 1</b-dropdown-item>
            <b-dropdown-item @click="unpostingselected" :disabled="(selected.length==0)">Unposting Selected {{selected.length}} </b-dropdown-item>

          </b-dropdown>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>

        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>

            <b-input-group >
              <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" style="width:23% !important;"></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" style="width:23% !important;"></b-form-input>
                <b-input-group-prepend><span class="ml-2 pt-2">Outstand &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll" style="padding:0 !important;"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label class="text-right">Expense AP-Acc.</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.kodeacc" placeholder="Account Code"></b-form-input>
                      </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Acc. Name&nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>      
              <b-row>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><label class="text-right">Paid To</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.dibayarke" placeholder="Pay to"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
                    </b-input-group>
                  </b-col>
              </b-row>                      
            <b-input-group>
                <b-input-group-prepend><label class="text-right">Create By</label></b-input-group-prepend>
              <b-form-input v-model="tblData.createby" placeholder="input by" ></b-form-input>
              <b-input-group-prepend><span class="pt-2">Approval&nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
                <b-button class="btn btn-success ml-1" @click="search()"> Apply
                  Filter</b-button>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
                  </b-button>
              </b-input-group>

        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
          @row-clicked="rowClicked" 
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-expenKey="data.item.expenKey"
            :checked="ischeckedjurnal(data.item.expenKey)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <!-- <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting==1) || ((data.item.nomorbank||'')!='')" style="padding:0 !important;">Edit</b-dropdown-item> -->
          <b-dropdown-item @click="rowEdit(data.item)" href="#" :disabled="(data.item.posting==1) || ((data.item.nomorbank||'')!='') || (use_wfservice==1 && ((data.item.send2wf==1 && data.item.isreviewed == 0) || (data.item.send2wf==1 && data.item.iscomplete ==1)))" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#"  style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowPrintpb(data.item)" href="#"  style="padding:0 !important;">Print Perintah Bayar</b-dropdown-item>
          <b-dropdown-item @click="rowPost(data.item)" href="#" :disabled="((data.item.posting==1) || (data.item.nomorbank))" style="padding:0 !important;">Posting</b-dropdown-item>
          <b-dropdown-item @click="rowUnPost(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Un Posting</b-dropdown-item>
          <b-dropdown-item @click="rowPrintJv(data.item)" href="#" :disabled="(data.item.posting==0)" style="padding:0 !important;">Print JV</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="(use_wfservice==1 && (data.item.send2wf==1 || data.item.isreviewed == 1)) || (data.item.posting==1)" style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowAttachment(data.item)" href="#"  style="padding:0 !important;">Attachment</b-dropdown-item>
        </b-dropdown>
      </template>    
        <template v-slot:cell(nomor)="data">
            <span v-if="((data.item.posting==1) || (data.item.nomorbank))" >{{data.item.nomor}}</span>
            <span v-else style="background-color:yellow;"> {{data.item.nomor}}</span>
        </template>

        <template v-slot:cell(tglRequ)="data">
          {{ data.item.tglRequ | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tranbank_tanggal)="data">
          {{ data.item.tranbank_tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(final)="data">
          <span v-if="data.item.final==1">Final</span>
          <span v-else style="background-color:#a9a6a6;">Draft</span>
        </template>
        <template v-slot:cell(jumlah)="data">
          <span v-if="data.item.final==0" style="background-color:#a9a6a6;">           
            {{(data.item.jumlah)|numFormat}}
          </span>
          <span v-else> 
            <span v-if="((data.item.posting==1) || (data.item.nomorbank))">           
                {{data.item.jumlah|numFormat}}
            </span>
            <span v-else style="background-color:yellow;"> 
                {{data.item.jumlah|numFormat}}
            </span>
          </span>
        </template>
        <template v-slot:cell(nilaiByr)="data">
          {{data.item.nilaiByr|numFormat}}
        </template>
        <template v-slot:cell(outstand)="data">
          {{data.item.outstand|numFormat}}
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>  
        </template>
        <template v-slot:cell(download)="data">
                <b-link @click.stop="getAttachment(data.item)"><i class="fa fa-paperclip"></i></b-link>
        </template>

      </b-table>
      <b-row >
        <b-col cols="4">
          <div class="pt-1">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="5">          
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
              <b-pagination
                v-if="pagination" 
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3" >
          <div class="text-right pt-1">
            <span style="background-color:yellow;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-4">Record Not Posted</span>
            <span style="background-color:#a9a6a6;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Draft</span>
          </div>
        </b-col>        
      </b-row>      

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showSubmitConfirm" title="Submit as Final Record?" :centered="true" @ok="submitData">
        <p class="mb-1">The selected a row of data will be submited to Finance/Treasury?</p>
      </b-modal>
      <b-modal v-model="showUnsubmitConfirm" title="Un Submit as Draft Record?" :centered="true" @ok="unsubmitData">
        <p class="mb-1">The selected a row of data will be UnPosted from Finance/Treasury?</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>

      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Requesition No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.iscomplete==0)">
                      <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                          <i class="fa fa-trash"></i>
                      </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected File: <strong>{{ file ? file.name : '' }}</strong> Filesize:{{bytesToKB.showFileSize(file)}}</span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-aexpense {
      table {
        td:nth-child(1) {
          width: auto;
        }
        td:nth-child(2) {
          width: auto;
        }
        td {
          .dropdown-item {
              padding: 0.1rem 1.5rem !important;
              font-size: smaller !important;
          }    
        }
      }
  .input-group {
      .input-group-prepend {
          label {
              width: 110px !important;
          }
      }
  }  
 }
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../../apis/task";
import expense from "../../apis/expense";
import dropdown from "../../data/dropdown";
import bytesToKB from '../../libs/filesize-byte2kb';
import toastr from "mini-toastr";
import { mapState } from "vuex";
toastr.init();


export default {
  components: { Loading},
  data() {
    return {
      bytesToKB,
      showFilter: false,
      showDelConfirm: false,
      showAttachment: false,
      file:null,
      showSubmitConfirm:false,showUnsubmitConfirm:false,
      showPostingConfirm: false,showUnpostConfirm: false,
      use_wfservice: 0,
      isLoading:false,
      showReport:false,
      isprintjv: false,
      reportUrl: null,
      model:{},
      uanguser: "",
      items: [],
      pagination:false,
      limit:20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1: "",
        tgl2: moment().format('YYYY-MM-DD'),                
        sortBy: 'nomor',
        sortDesc: true,
        DimCol:'Dim1',outstand:'',statuswf:'111'
      },
      dataList: {
        approvalStatus:dropdown.approvalStatus,
        YesNoAll: dropdown.YesNoAll
      },      
      recordStatus: [{ value:'', text:'--ALL--'},{ value:'1', text:'Final'},{ value:'0', text:'Draft'}],
      selected:[],
      attachmens: [],
    };
  },
  computed: {
    ...mapState(["user", "dimension", "filter"]),
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tglRequ",
            thStyle: "width:90px",
            label: "Trx. Date",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Create By",
            sortable: true
          },
          {
            key: "dibayarke",
            label: "Paid To",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Requested Amount",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: 'download',
            label: "Attach",
            thClass: "text-center",
            tdClass: "text-center",
        },
        {
          key: "issuccess",
          label: "Approval Status",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
          {
            key: "nilaiByr",
            label: "Paid",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "nomorbank",
            label: "Trx.Bank/Cash",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "tranbank_tanggal",
            label: "Paid Date",
            thStyle: "min-width:100px",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ];
        const dims = this.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            // thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  created: async function () {
    this.use_wfservice = this.user.use_wfservice;
    this.uanguser = this.user.matauang;
    this.tblData.tgl1 = this.user.tglaktif;
    const approvalConfig = await expense.approvalConfig();
    if (!approvalConfig) this.use_wfservice = 0;
  },

  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        // this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    "user.tglaktif": function (newVal) {
      if (newVal) this.tblData.tgl1 = newVal;
    },
    "user.matauang": function (newVal) {
      if (newVal) this.uanguser = newVal;
    },
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  methods: {
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        await advance.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log('error : ', error);
        if (error.sql) {
          toastr.error(error.sql, 'ERROR MESSAGE', 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, 'ERROR MESSAGE', 10000);
        } else if (error.message) {
          toastr.error(error.message, 'ERROR MESSAGE', 10000);
        } else {
          toastr.error(JSON.stringify(error), 'ERROR MESSAGE', 10000);
        }
      }
    },

    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
      // $('[name="selectjurnal"]').each(function() {
      //     $(this).prop("checked", false);
      //   });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const expenKey = item.target.attributes["data-expenKey"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === expenKey);
        if (!(findjv)){
          this.selected.push(expenKey);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === expenKey);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
      this.pagination=false;
        const filter = this.filter;
        let filtered=false;
        for (var key in filter.expreqlist) {
            this.tblData[key] = filter.expreqlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.expreqlist.tgl1 || '';
          this.tblData.tgl2=filter.expreqlist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.expreqlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
          const list = await expense.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
                try {
          const list = await expense.list(this.tblData);      
                  this.items=list;
                  this.isLoading=false;
                  this.pagination=true;
                  return list;
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    clearFilter(ctx) {
        this.tblData.kodeaccc= '';
        this.tblData.namaacc=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.dibayarke=  '';
        this.tblData.createby=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'dibayarke', 'kodeacc', 'namaacc', 'isProject', 'crewkey', 'crewname','createby', 'final'];
      let filtered = false;
      const expreqlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              expreqlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          expreqlist.page=this.tblData.page;
          expreqlist.limit=this.tblData.limit;
          expreqlist.sortBy=this.tblData.sortBy;
          expreqlist.sortDesc=this.tblData.sortDesc;
          const filter = this.filter;
          filter.expreqlist=expreqlist;
          this.$store.commit("filter", filter);
      }
    },     
    rowAttachment(record) {
      this.model = record;
      this.getAttachment(record);
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.expenKey});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        console.log('error : ', error);
        if (error.sql) {
            toastr.error(error.sql,'ERROR MESSAGE',10000);
        } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
        } else if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.expenKey);
                formData.append('tableName', 'expenreimburs');
                formData.append("filesize", bytesToKB.showFileSize(this.file));
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.expenKey});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.requestkey});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
              // this.close();
      })
      .catch(err => {
      // An error occurred
      })                

    },      

    rowEdit(record) {
      this.rowClicked(record);
      this.edit();
    },
    rowPost(record) {
      this.rowClicked(record);
        this.posting();        
    },
    rowUnPost(record) {
      this.rowClicked(record);
        this.unposting();        
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },    
    rowPrintJv(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowPrintpb(record) {
      this.rowClicked(record);
        this.printpb();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add(){
      this.saveFilter();
      router.push({name :"advance.expreimbursfrm"});
    },
    edit: function() {
        if (this.model.expenKey) {
          this.saveFilter();
          router.push({name :'advance.expreimbursfrm', params: { expenKey: this.model.expenKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.expenKey) {
          if (this.model.send2wf == 1) {
            toastr.warn('Row cannot be deleted!');
          }else{
            this.showDelConfirm = true;
          }
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
        this.isLoading=true;
        await expense.remove(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.expenKey==this.model.expenKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
    },
    
    rowClicked(record, index) {
      console.log('record',record)
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.expenKey) {
            if (this.model.posting == 0) {
              if ((this.model.matauang!=this.uanguser) && ((this.model.ratekurs || 1)==1))
              {
                toastr.warn(`Please EDIT and fill the Exchange Rate ${this.model.matauang} !`);
              } else {
                this.showPostingConfirm = true;
              }
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    },
    unposting:async function () {
        if (this.model.expenKey) {
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    },
    postingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await expense.postingselected(this.selected);
          this.printjvmultiple();
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    unpostingselected: async function() {
      this.isLoading = true;
      try {
        if (this.selected.length > 0) {
          await expense.unpostingselected(this.selected);
          this.selected = [];
          this.refresh();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          toastr.warn("Please select row(s) that want to be Posting!");
        }
      } catch (error) {
        this.isLoading = false;
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    postingData: async function(){
        this.isLoading=true;
        try {
            await expense.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await expense.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },  
    print: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.print(this.model);
              this.isprintjv=false;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpb: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printpb(this.model);
              this.isprintjv=false;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printpbmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printpbmultiple(this.selected);
              this.isprintjv=false;
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },

    printjv: async function()
    {
      if (this.model.expenKey) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printjv(this.model);
              this.isprintjv=true;
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    editjv: function() {
        if (this.model.expenKey) {
            this.saveFilter();
            const tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
          // router.push({name :'advance.editjvfrm', params: { nomor: this.model.nomor, tanggal, kodejurnal:'APINV', fsubkode2:'ap_invoice_tt',kodefield2:'apinvkey',subkode2: this.model.apinvkey}});
          router.push({name :'advance.editjvfrm', params: { nomor: this.model.nomor, tanggal: this.model.tglRequ}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    

    printjvmultiple: async function()
    {
      if (this.selected) {
          try {
                this.showReport=true;
              this.reportUrl= await expense.printjvmultiple(this.selected);
              this.isprintjv=false;
              this.selected = [];
          } catch (error) {
            console.log(error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
        } else {
            toastr.warn('Please select row(s) that want to be Printed!');
        }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.DimColInfo=(this.dimension.find(d => d.value === this.tblData.DimCol) || {}).text;
            const response = await expense.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/advance/home");
    },    
  }
};
</script>
